@if (isPartner$ | async) {
  <div class="migration-banner">
    <i class="material-icons migration-banner__icon">info</i>
    <div
      class="migration-banner__content"
      [innerHTML]="'PAGES.CREATE_FROM_TEMPLATES.MIGRATION_BANNER.MESSAGE' | translate"
    ></div>
  </div>
}
@if (productName$ | async; as productName) {
  <div class="banner">
    <div class="main-container wrap">
      <i class="material-icons cloud">cloud</i>
      <div class="info">
        @if (templateSelectionStep) {
          <span class="title">
            {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATES_BANNER.TITLE' | translate: { productName: productName } }}
          </span>
          <br />
          <p>
            {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATES_BANNER.SUBTITLE1' | translate }}
          </p>
          <div>
            {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATES_BANNER.IMPORT_TITLE' | translate }}
            <a mat-button class="import-button" (click)="openImportDialog()">
              {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATES_BANNER.IMPORT_BUTTON_TEXT' | translate }}
            </a>
          </div>
        } @else {
          <span class="title">
            {{ 'PAGES.CREATE_FROM_TEMPLATES.CREATE_BANNER.TITLE' | translate: { productName: productName } }}
          </span>
          <br />
          <p>
            {{ 'PAGES.CREATE_FROM_TEMPLATES.CREATE_BANNER.SUBTITLE' | translate }}
          </p>
        }
      </div>
    </div>
  </div>
  <mat-horizontal-stepper
    #stepper
    linear
    labelPosition="bottom"
    class="create-stepper"
    (selectionChange)="stepperClicked($event)"
    >
    <mat-step [completed]="isStepCompleted">
      <ng-template matStepLabel>
        {{ 'PAGES.CREATE.STEPS.STEP_2' | translate }}
      </ng-template>
      <app-template (isTemplateSelected)="nextPage($event)"></app-template>
    </mat-step>
    <mat-step [stepControl]="domainFormGroup">
      <ng-template matStepLabel>
        {{ 'PAGES.CREATE.STEPS.STEP_1' | translate }}
      </ng-template>
      @if ((loading$ | async) === false) {
        <mat-card appearance="outlined" class="page page-narrow">
          <mat-card-header>
            <mat-card-title>{{ 'PAGES.CREATE.TITLE' | translate }}</mat-card-title>
          </mat-card-header>
          <form [formGroup]="domainFormGroup" (ngSubmit)="onSubmit()">
            <p>
              <mat-form-field class="create--full-width">
                <input
                  matInput
                  type="text"
                  formControlName="siteTitle"
                  required
                  name="siteTitle"
                  placeholder="{{ 'PAGES.CREATE.PLACEHOLDER.SITE' | translate }}"
                  maxlength="{{ maxLength }}"
                  />
                @if (
                  !!domainFormGroup.controls['siteTitle'].value &&
                  domainFormGroup.controls['siteTitle'].value.length > maxLength - 15
                  ) {
                  <mat-hint
                    >
                    {{ 'PAGES.CREATE.CHARACTERS_REMAINING' | translate }}:
                    {{ calculateRemainingChars(domainFormGroup.controls['siteTitle'].value.length) }}
                  </mat-hint>
                }
              </mat-form-field>
            </p>
            <p>
              <mat-form-field class="create--full-width">
                <input
                  matInput
                  type="text"
                  formControlName="siteTagline"
                  required
                  name="siteTagline"
                  placeholder="{{ 'PAGES.CREATE.PLACEHOLDER.BUSINESS' | translate }}"
                  maxlength="{{ maxLength }}"
                  />
                @if (
                  !!domainFormGroup.controls['siteTagline'].value &&
                  domainFormGroup.controls['siteTagline'].value.length > maxLength - 15
                  ) {
                  <mat-hint
                    >
                    {{ 'PAGES.CREATE.CHARACTERS_REMAINING' | translate }}:
                    {{ calculateRemainingChars(domainFormGroup.controls['siteTagline'].value.length) }}
                  </mat-hint>
                }
              </mat-form-field>
            </p>
            <p>
              <mat-form-field class="create--full-width">
                <input
                  matInput
                  type="text"
                  formControlName="defaultDomain"
                  required
                  name="defaultDomain"
                  maxlength="{{ maxSubDomainLength }}"
                  placeholder="{{ 'PAGES.CREATE.PLACEHOLDER.FREE_DOMAIN' | translate }}"
                  />
                <span class="input-suffix" matSuffix>
                  @if (!multisite) {
                    {{ defaultDomainSuffix }}
                  }
                  @if (multisite) {
                    {{ msDomainSuffix }}
                  }
                </span>
                @if (
                  !!domainFormGroup.controls['defaultDomain'].value &&
                  calculateRemainingSubdomainChars(domainFormGroup.controls['defaultDomain'].value.length) <= 15
                  ) {
                  <mat-hint
                    >
                    {{ 'PAGES.CREATE.CHARACTERS_REMAINING' | translate }}:
                    {{ calculateRemainingSubdomainChars(domainFormGroup.controls['defaultDomain'].value.length) }}
                  </mat-hint>
                }
              </mat-form-field>
            </p>
            <button mat-raised-button [disabled]="domainFormGroup.invalid" class="wide-button nextButton" type="submit">
              {{ 'PAGES.CREATE.BUTTONS.LAUNCH_YOUR_SITE' | translate }}
            </button>
          </form>
        </mat-card>
      } @else {
        <mat-spinner class="info-spinner" color="accent" [diameter]="60" [strokeWidth]="8"></mat-spinner>
      }
    </mat-step>
    <mat-step [editable]="false">
      <ng-template matStepLabel>
        {{ 'PAGES.CREATE.STEPS.STEP_3' | translate }}
      </ng-template>
    </mat-step>
  </mat-horizontal-stepper>
} @else {
  <mat-spinner class="info-spinner" color="accent" [diameter]="60" [strokeWidth]="8"></mat-spinner>
}
